// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__eKV88","error":"Textarea_error__1637P","readonly":"Textarea_readonly__2O8uu","disabled":"Textarea_disabled__1TBtM"};